import React from 'react';
import styled from 'styled-components';
import { IoChevronDownOutline } from 'react-icons/io5';

const BalanceButton = ({ children, isOpen, toggleMenu, isSmallScreen }: Props) => {
	return (
		<StyledButton id="balance-button" onClick={toggleMenu} $smallScreen={isSmallScreen} $isOpen={isOpen}>
			<span>{children}</span>
			<span>
				<IoChevronDownOutline />
			</span>
		</StyledButton>
	);
};

export default BalanceButton;

interface Props {
	toggleMenu: () => void;
	children: string;
	isSmallScreen: boolean;
	isOpen: boolean;
}

const StyledButton = styled.button<{ $isOpen: boolean; $smallScreen: boolean }>`
	display: flex;
	border-radius: 5px;
	color: ${({ theme }) => theme.colors.darkGrey};
	align-items: center;
	overflow: hidden;
	highlight: none;
	z-index: ${({ $isOpen }) => ($isOpen ? '61' : 'inherit')};
	position: relative;

	span {
		display: block;
		background-color: ${({ theme }) => theme.colors.white};
		font-weight: 600;
		padding: ${({ $smallScreen }) => ($smallScreen ? '6px 6px' : '6px')};
		font-size: ${({ $smallScreen }) => ($smallScreen ? '0.8rem' : '1rem')};

		&:first-child {
			padding: ${({ $smallScreen }) => ($smallScreen ? '6px 6px' : '6px 12px')};
			margin-right: 1px;
		}
	}
`;
